export interface HeaderLocationState {
  state: string;
  stateAbbr: string;
  cities: string[];
}

export const HEADER_LOCATIONS: HeaderLocationState[] = [
  { state: "Texas", stateAbbr: "TX", cities: ["Dallas", "Fort Worth", "Houston", "Austin", "San Antonio"] },
  { state: "Florida", stateAbbr: "FL", cities: ["Miami", "Orlando", "Tampa Bay", "Palm Beach"] },
  { state: "California", stateAbbr: "CA", cities: ["Los Angeles", "San Francisco", "Sacramento", "San Diego", "Fresno", "San Jose", "Bakersfield", "Oakland"] },
  { state: "New York", stateAbbr: "NY", cities: ["New York City"] },
  { state: "Georgia", stateAbbr: "GA", cities: ["Atlanta", "Athens", "Augusta", "Savannah"] },
  { state: "Arizona", stateAbbr: "AZ", cities: ["Tempe", "Phoenix", "Scottsdale", "Tucson"] },
  { state: "North Carolina", stateAbbr: "NC", cities: ["Raleigh", "Charlotte", "Asheville"] },
  { state: "South Carolina", stateAbbr: "SC", cities: ["Charleston", "Myrtle Beach", "Columbia", "Greenville"] },
  { state: "Tennessee", stateAbbr: "TN", cities: ["Nashville", "Memphis", "Knoxville"] },
  { state: "Pennsylvania", stateAbbr: "PA", cities: ["Philadelphia", "Pittsburgh"] },
  { state: "Illinois", stateAbbr: "IL", cities: ["Chicago"] },
];

export const headerLocationRoute = (city: string, stateAbbr: string): string => city.replace(/\s+/g, "-") + "-" + stateAbbr;

const COMMERCE_NAVIGATION_ROOTS = new Set(["shop"]);

/** Shop pages get the ecommerce navigation; every rental/equipment page keeps the original header. */
export const isCommerceNavigationUrl = (url: string): boolean =>
  COMMERCE_NAVIGATION_ROOTS.has((url || "").split(/[?#]/)[0].split("/").filter(Boolean)[0] || "");
